<template>
  <div class="exp">
    <div class="item" v-for="item in list">
      <img :src="item.medal" alt="">
      <div>所需经验{{item.exp}}</div>
    </div>
  </div>
</template>

<script>
  import {actions} from '../store/actions'
  export default {
    data () {
      return {
        list: {}
      }
    },
    created () {
      this.getExpDesc()
    },
    methods: {
      getExpDesc () {
        let _this = this
        actions.getExpDesc(_this, {uid: localStorage.getItem('wxUid')}, function (data) {
          _this.list = data
        })
      }
    }

  }
</script>
<style scoped>
  .exp{
    padding: .1rem .56rem .5rem .56rem;
    background-color: #fff;
    color: #2F2F2F;
    overflow: hidden;
  }
  .exp .item{
    float: left;
    width: 1.56rem;
    margin-right: .85rem;
    margin-top: .54rem;
    font-size: .26rem;
    color: #2F2F2F;
    text-align: center;
  }
  .exp .item:nth-child(3n){
    margin-right: 0;
  }
  .exp .item img{
    width: 100%;
    margin-bottom: .2rem;
  }
</style>



// WEBPACK FOOTER //
// ExpDesc.vue?b4108ff0